import { searchProduct } from "../api/dataFactory";
import { getImage } from "../api/dataFactory";
const PRODUCT_PER_PAGE = 10;

const productSearchMixins = {
  props: {
    page: {
      type: String,
      default: "1"
    },
    keyword: String
  },
  metaInfo: {
    title: "Health Care | 1byone",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Take care of your health with best products-1byone massagers,blood pressure monitor,6in1 thermometer,muscle stimulator,fingertip pulse oximeter and more."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone,1byonehealth, massagers,blood pressure monitor,bluetooth blood pressure monitor,6in1 thermometer,muscle stimulator,fingertip pulse oximeter,mechanical bidet,electrode pads"
      }
    ]
  },
  data() {
    return {
      getImage,
      products: [],
      rating: 5,
      loading: true
    };
  },
  created() {
    this.initData();
  },

  methods: {
    async initData() {
      this.resetData();
      this.products = await searchProduct(this.searchParams);
      this.loading = false;
    },

    getProductImage(id, productImage) {
      let path = "/product/" + id + "/" + productImage;
      return this.getImage(path);
    },

    getProductDetailPageUrl(product) {
      // return "/product/dp/" + product.id;
      // return "/product/" + product.id;
      // return "/p/" + product.id;
      return "/" + product.id;
    },

    resetData() {
      this.loading = true;
      this.products = [];
    },

    getSearchResultErrorHint() {
      let hint = "";
      if (this.keyword) {
        hint = this.keyword;
      }
      return hint;
    }
  },
  computed: {
    searchResultHeader() {
      let searchResultsCount = this.products.length;
      let searchKeywords = this.keyword;
      return `${searchResultsCount} Search Results For "${searchKeywords}"`;
    },
    hasSearchResult() {
      return (
        !this.loading && this.products != undefined && this.products.length > 0
      );
    },

    hasNoSearchResult() {
      return (
        !this.loading &&
        (this.products == undefined || this.products.length == 0)
      );
    },

    searchParams() {
      return {
        keyword: this.keyword,
        size: PRODUCT_PER_PAGE,
        from: PRODUCT_PER_PAGE * this.page - PRODUCT_PER_PAGE
      };
    },

    searchResultHintText() {
      return `Search Result For '${this.getSearchResultErrorHint()}'`;
    },

    searchResultFullHintText() {
      return `We are sorry, no result found for your search term '${this.getSearchResultErrorHint()}'`;
    }
  },

  watch: {
    searchParams: {
      handler: "initData",
      deep: true
    }
  }
};

export default productSearchMixins;
